import {Inject, Injectable} from '@angular/core';
import {DateRange, MatDateRangeSelectionStrategy} from "@angular/material/datepicker";
import {DateAdapter} from "@angular/material/core";
import { ReportDateRangeService } from './report-date-range.service';

@Injectable()
export class MaxRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  start: any;

  // constructor(
  //   @Inject('rangeMax') private delta: number,
  //   private _dateAdapter: DateAdapter<D>
  // ) {}

  // selectionFinished(date: D, currentRange: DateRange<D>) {
  //   let { start, end } = currentRange;
  //   if (start == null || (start && end)) {
  //     start = date;
  //     end = null;
  //   } else if (end == null) {
  //     const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
  //     if(date){
  //       if(date > maxDate){
  //         end=maxDate
  //       }else if(date < start){
  //         start=date
  //         end=null
  //       }else{
  //         end= date
  //       }
  //     }else{
  //       end= null
  //     }

  //   }

  //   return new DateRange<D>(start, end);
  // }



  // createPreview(activeDate: D | null, currentRange: DateRange<D>): DateRange<D> {
  //   if (currentRange.start && !currentRange.end) {
  //     const maxDate = this._dateAdapter.addCalendarDays(currentRange.start, this.delta);
  //     const rangeEnd = activeDate ? activeDate > maxDate ? maxDate : activeDate : null;
  //     return new DateRange(currentRange.start, rangeEnd);
  //   }

  //   return new DateRange<D>(null, null);
  // }


  constructor(
    private _dateAdapter: DateAdapter<D>,
    private _rangeService: ReportDateRangeService
  ) {}

  selectionFinished(date: D | null, currentRange: DateRange<D>): DateRange<D> {
    const rangeValue = this._rangeService.getMaxRangeValue();
    const unit = this._rangeService.getMaxRangeUnit();

    let start = currentRange.start;
    let end = currentRange.end;

    // ✅ If both dates already selected, reset and start fresh from the clicked date
    if (start && end) {
      start = date;
      end = null;
    }

    // ✅ If only start is selected and user picks a new end
    else if (start && !end && date) {
      let maxEnd: D;
      if (unit === 'months') {
        maxEnd = this._dateAdapter.addCalendarMonths(start, rangeValue);
      } else {
        maxEnd = this._dateAdapter.addCalendarDays(start, rangeValue);
      }

      if (this._dateAdapter.compareDate(date, start) < 0) {
        // If user picks before start, make it new start
        start = date;
        end = null;
      } else if (this._dateAdapter.compareDate(date, maxEnd) > 0) {
        end = maxEnd;
      } else {
        end = date;
      }
    }

    // ✅ If no start selected, use clicked date as start
    else if (!start) {
      start = date;
    }

    return new DateRange<D>(start, end);
  }

  createPreview(activeDate: D | null, currentRange: DateRange<D>): DateRange<D> {
    const start = currentRange.start;
    const range = this._rangeService.getMaxRangeValue();
    const unit = this._rangeService.getMaxRangeUnit();

    if (start && !currentRange.end) {
      let maxAllowedEnd: D;

      if (unit === 'months') {
        maxAllowedEnd = this._dateAdapter.addCalendarMonths(start, range);
      } else {
        maxAllowedEnd = this._dateAdapter.addCalendarDays(start, range);
      }

      if (activeDate) {
        const end =
          this._dateAdapter.compareDate(activeDate, maxAllowedEnd) > 0
            ? maxAllowedEnd
            : activeDate;
        return new DateRange(start, end);
      }
    }

    return new DateRange<D>(null, null);
  }
}

